import React from 'react'
import { useSelector } from 'react-redux'

import PostpaidOfferSetup from './components/PostpaidOfferSetup'
import PrepaidOfferSetup from './components/PrepaidOfferSetup'

import { selectIsPostpaid } from '~/sale/store/sale.selectors'

export default function OfferSetUpPage() {
  const isPostpaid = useSelector(selectIsPostpaid)
  return isPostpaid ? <PostpaidOfferSetup /> : <PrepaidOfferSetup />
}
